import styled from '@emotion/styled';
import * as React from 'react';
import { TagBadgeWidget, TagBadgeToneLike } from './TagBadgeWidget';

export interface InlineBadgeLabelWidgetProps {
  badge?: string;
  label: string;
  sinceVersion?: string;
  tone?: TagBadgeToneLike;
}

export const InlineBadgeLabelWidget: React.FC<InlineBadgeLabelWidgetProps> = ({ badge, label, sinceVersion, tone }) => {
  return (
    <S.Root>
      <code>{label}</code>
      {badge ? (
        <TagBadgeWidget sinceVersion={sinceVersion} tone={tone}>
          {badge}
        </TagBadgeWidget>
      ) : null}
    </S.Root>
  );
};

namespace S {
  export const Root = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
  `;
}
